import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { formatDateTime } from '../../../../../_metronic/helpers/crud-helper/helpers'
import { TableCard } from '../../../../components/Table/TableCard'
import { TableErrorState } from '../../../../components/Table/TableStates'
import { DetailField, DetailPanel } from '../../../../components/DetailPanel/DetailPanel'
import { ConteudoVersaoLeitura } from '../components/ConteudoVersaoLeitura'
import { extrairErrosProtocolo } from '../core/errosProtocolo'
import { ProtocoloDetalheHeading } from './components/ProtocoloDetalheHeading'
import { useProtocoloDetalhe } from './core/useProtocoloDetalhe'

/** Detalhe de uma versão do protocolo da empresa (T7a AC2/AC4/AC5). */
export const ProtocoloDetalhePage: FC = () => {
  const { data: versao, isLoading, isError, error, refetch, catalogo } = useProtocoloDetalhe()

  if (error && extrairErrosProtocolo(error).status === 403) {
    return <Navigate to='/error/404' />
  }

  if (isError) {
    return (
      <TableCard>
        <TableErrorState title='Não foi possível carregar a versão.' onRetry={refetch} />
      </TableCard>
    )
  }

  if (isLoading || !versao) {
    return (
      <TableCard>
        <DetailPanel isLoading loadingLabel='Carregando versão…' />
      </TableCard>
    )
  }

  const vigencia = versao.dtInicioVigencia
    ? `${formatDateTime(versao.dtInicioVigencia)} — ${
        versao.dtFimVigencia ? formatDateTime(versao.dtFimVigencia) : 'atual'
      }`
    : undefined

  return (
    <>
      <ProtocoloDetalheHeading versao={versao} catalogo={catalogo} onAprovado={() => refetch()} />
      <TableCard>
        <ConteudoVersaoLeitura
          hash={versao.hash}
          hashAusente='ainda não calculado (rascunho)'
          campos={
            <>
              <DetailField label='Formulário vinculado' value={versao.formulario?.nome} />
              <DetailField label='Vigência' value={vigencia} emptyLabel='Sem vigência' />
            </>
          }
          regras={versao.regras}
          formulario={versao.formulario}
          catalogo={catalogo}
          rotuloFormulario='Formulário vinculado'
          formularioBloqueado={versao.formularioBloqueado}
          motivoBloqueioFormulario={versao.motivoBloqueioFormulario}
        />
      </TableCard>
    </>
  )
}
